/*
    usePaint
    ---
    Defines a paint prop and provides a computed property for it.
    Components can use this to apply a dynamic paint color.
*/

import { computed, provide, inject } from 'vue';

const paintProps = () => {
    return {
        paint: {
            type: String,
            default: null,
        },
    };
};

function usePaint(props) {
    const paint = computed(() => {
        return props.paint;
    });

    return { paint };
}

export { usePaint as default, usePaint, paintProps };
